import { Pipe, PipeTransform } from '@angular/core';
import { DqsDatePipe } from '@pipe/dqs-date.pipe';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

@Pipe({
  name: 'timeFromNow',
})
export class TimeFromNowPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return;
    }

    const moreThanDay = dayjs(new Date()).diff(dayjs(value), 'd') > 1;

    if (moreThanDay) {
      return new DqsDatePipe().transform(value, true);
    }

    return dayjs(value).fromNow();
  }

}
